import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { Router, useRouter } from 'next/dist/client/router';
import { hooks } from '@bob/design-system';
import { sort, SortType } from './sort';
import { usePagination } from './usePagination';
import { useQuery } from './useQuery';
import { useSearch } from './useSearch';
export function useSearchEngine(items, config) {
  var router = useRouter();
  var search = useSearch(items, config);
  var query = useQuery(config.defaultQuery);
  var pagination = usePagination({
    page: 1,
    size: Infinity
  }, search.result.list);
  var searchRef = React.useRef(search);
  searchRef.current = search;
  var paginationRef = React.useRef(pagination);
  paginationRef.current = pagination;
  var queryRef = React.useRef(query);
  queryRef.current = query;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isReady = _React$useState2[0],
      setIsReady = _React$useState2[1];

  React.useEffect(function () {
    setUrlParams(window.location.search);
    Router.events.on('routeChangeComplete', onRouteChangeComplete);
    return function () {
      Router.events.off('routeChangeComplete', onRouteChangeComplete);
    };

    function onRouteChangeComplete(targetUrl) {
      var url = new URL(window.location.origin + targetUrl);
      var parsed = parse(url.search);
      paginationRef.current.paginate(parsed['page'] || config.defaultPage);
    }
  }, []);
  React.useEffect(function () {
    if (!isReady) {
      if (search.status !== 'request') {
        setIsReady(true);
      }
    }
  }, [search]);
  var setQueryDebounced = hooks.useDebounce(setQuery, false);
  var resultSort = config.sorts.find(function (sort) {
    return sort.type === query.value.sortType;
  });
  var sortedItems = resultSort ? sort(search.result.list, resultSort) : search.result.list;
  return {
    ready: isReady,
    result: {
      status: search.status,
      total: search.result.list.length,
      page: sortedItems.slice((pagination.page - 1) * pagination.size, pagination.page * pagination.size),
      facets: search.result.facets
    },
    search: search.search,
    sort: {
      configSort: config.sorts,
      sort: sortItems
    },
    query: _objectSpread(_objectSpread({}, query), {}, {
      add: add,
      remove: remove,
      reset: reset,
      text: text
    }),
    pagination: _objectSpread(_objectSpread({}, pagination), {}, {
      pageHref: pageHref,
      setSize: setSize
    })
  };

  function add(index, bucket) {
    var nextQuery = query.add(index, bucket);
    onQueryChange(false, nextQuery);
  }

  function remove(index, bucket) {
    var nextQuery = query.remove(index, bucket);
    onQueryChange(false, nextQuery);
  }

  function reset() {
    var nextQuery = query.reset();
    onQueryChange(false, nextQuery);
  }

  function sortItems(sortType) {
    var nextQuery = query.sort(sortType);
    onQueryChange(false, nextQuery);
  }

  function text(text) {
    var nextQuery = query.text(text);
    setQueryDebounced(nextQuery);
  }

  function pageHref(page) {
    var url = getPageUrl(_objectSpread(_objectSpread({}, pagination), {}, {
      page: page
    }));
    return url.toString().replace(url.origin, '');
  }

  function setSize(size) {
    var nexPagination = pagination.setSize(size);
    onPaginationChange(nexPagination);
  }

  function onQueryChange(initial, query) {
    setQuery(query);
    var url = new URL(window.location.href);
    url.search = stringify({
      filters: query.filters,
      sort: query.sortType !== config.defaultQuery.sortType ? SortType[query.sortType] : undefined
    });

    if (initial) {
      router.replace(url, undefined, {
        shallow: true
      });
    } else {
      router.push(url, undefined, {
        shallow: true
      });
    }
  }

  function setQuery(query) {
    search.search(query);
    pagination.paginate(1);
  }

  function getPageUrl(pagination) {
    var url = new URL(window.location.href);
    var params = {
      filters: query.value.filters,
      sort: SortType[query.value.sortType]
    };

    if (pagination.size !== config.defaultSize) {
      params.size = pagination.size;
    }

    if (pagination.page !== 1) {
      params.page = pagination.page;
    }

    url.search = stringify(params);
    return url;
  }

  function onPaginationChange(pagination) {
    router.push(getPageUrl(pagination), undefined, {
      shallow: true
    });
  }

  function setUrlParams(searchString) {
    var _parsed$searchableTag;

    var parsed = parse(searchString);
    paginationRef.current.set(parsed['page'] || config.defaultPage, parsed['size'] || config.defaultSize);
    var defaultSortType = config.defaultQuery.sortType;
    var sortType = defaultSortType;

    if (parsed.sort !== undefined) {
      // On vérifie si la string passé dans l'url correspond avec un
      // type de sort existant sinon on revient a celui par default
      sortType = SortType[parsed.sort] !== undefined ? SortType[parsed.sort] : sortType;
    } // Si jamais on passe dans l'url un number au lieu d'une string


    if (typeof sortType === 'string') {
      sortType = defaultSortType;
    } // Hack du type parce qu'il veut que parsed.sort soit un number / any
    // mais alors la variable sortType devient de type string alors que c'est bien un SortType
    // d'ou le force avec as pour le remettre du bon type


    var query = {
      text: (_parsed$searchableTag = parsed.searchableTag) !== null && _parsed$searchableTag !== void 0 ? _parsed$searchableTag : '',
      filters: parsed.filters,
      sortType: sortType
    };
    queryRef.current.set(query);
    searchRef.current.search(query);
  }
}

function parse(searchString) {
  var search = new URLSearchParams(searchString);
  var parsed = {
    filters: {}
  };
  var gclid = search.get('gclid');
  parsed['gclid'] = gclid === null ? undefined : String(gclid);
  search["delete"]('gclid');
  var searchableTag = search.get('searchableTag');
  parsed['searchableTag'] = searchableTag === null ? undefined : String(searchableTag);
  search["delete"]('searchableTag');
  var page = search.get('page');
  parsed['page'] = page === null ? undefined : Number(page);
  search["delete"]('page');
  var size = search.get('size');
  parsed['size'] = size === null ? undefined : Number(size);
  search["delete"]('size');
  var sort = search.get('sort');
  parsed['sort'] = sort === null ? undefined : String(sort);
  search["delete"]('sort');
  var utmCampaign = search.get('utm_campaign');
  parsed['utm_campaign'] = utmCampaign === null ? undefined : String(utmCampaign);
  search["delete"]('utm_campaign');
  var utmSource = search.get('utm_source');
  parsed['utm_source'] = utmSource === null ? undefined : String(utmSource);
  search["delete"]('utm_source');
  var utmMedium = search.get('utm_medium');
  parsed['utm_medium'] = utmMedium === null ? undefined : String(utmMedium);
  search["delete"]('utm_medium');

  var _kx = search.get('_kx');

  parsed['_kx'] = _kx === null ? undefined : String(_kx);
  search["delete"]('_kx');

  var _iterator = _createForOfIteratorHelper(search.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      parsed.filters[key] = value.split(',');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parsed;
}

function stringify(parsed) {
  var search = new URLSearchParams();

  if (parsed.page !== undefined) {
    search.set('page', String(parsed.page));
  }

  if (parsed.size !== undefined) {
    search.set('size', String(parsed.size));
  }

  if (parsed.sort !== undefined) {
    search.set('sort', String(parsed.sort));
  }

  for (var _i = 0, _Object$entries = Object.entries(parsed.filters); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    search.set(key, value.join(','));
  }

  search.sort();
  return search.toString();
}